import dayjs from "dayjs";
import { roundDecimalValueUptoTwo } from "./roundDecimalValue";

export const calculateStoreAge = (openDate) => {
	const startdate = dayjs(openDate);
	const currentDate = dayjs();

	return roundDecimalValueUptoTwo(Math.abs(startdate.diff(currentDate, "M") / 12));
};
